import { DragDropContext } from 'react-beautiful-dnd';
import { allDropableID } from '../../data/defaultSchema';
import { changeDestinationFunction, sameDestinationFunction } from '../../utils/dragableFunctions';

interface mainPorps {
  stateProps: any;
  children: JSX.Element;
}
const { yAxisId, tableId } = allDropableID;

const DragableWrapper = (mainPorps: mainPorps) => {
  const { chartsData, yAxisData, setYAxisData, tablesData, setTablesData } = mainPorps.stateProps;

  const conditionFuctionWithData = (
    source: conditionFuctionWithDataProps,
    destination: conditionFuctionWithDataProps
  ) => {
    const dataByDroppableId = (Id: string) => {
      if (Id.match(yAxisId)) {
        return { data: yAxisData, setData: setYAxisData };
      }
      if (Id.match(tableId)) {
        return { data: tablesData, setData: setTablesData };
      }

      return { data: [], setData: () => {} };
    };
    const sourceData = dataByDroppableId(source.droppableId);
    const destinationData = dataByDroppableId(destination.droppableId);
    if (source.droppableId === destination.droppableId) {
      return {
        sameDestionation: true,
        sourceData: sourceData.data,
        setSourceData: sourceData.setData,
        destinationData: destinationData.data,
        setDestinationData: destinationData.setData,
      };
    }
    return {
      sameDestionation: false,
      sourceData: sourceData.data,
      setSourceData: sourceData.setData,
      destinationData: destinationData.data,
      setDestinationData: destinationData.setData,
    };
  };
  function handleOnDragEnd(result: any) {
    if (!result.destination) return;
    const { source, destination } = result;

    const { sameDestionation, sourceData, setSourceData, destinationData, setDestinationData } =
      conditionFuctionWithData(source, destination);

    // if source and destination are same
    if (sameDestionation) {
      const sameDestinationProps = {
        setSourceData,
        result,
      };
      sameDestinationFunction(sameDestinationProps);
      return;
    }

    // if source and destination are not same
    const changeDestinationProps = {
      sourceData,
      setSourceData,
      result,
      destinationData,
      setDestinationData,
      chartsData,
      stateProps: mainPorps.stateProps,
    };
    changeDestinationFunction(changeDestinationProps);
  }

  return (
    <>
      <DragDropContext onDragEnd={handleOnDragEnd}>{mainPorps.children}</DragDropContext>
    </>
  );
};

export default DragableWrapper;

interface conditionFuctionWithDataProps {
  index: number;
  droppableId: string;
}
